import TutorialStep1 from "assets/illustrations/tutorial/tutorial_step1.svg";
import TutorialStep2 from "assets/illustrations/tutorial/tutorial_step2.svg";
import TutorialStep3 from "assets/illustrations/tutorial/tutorial_step3.svg";
import TutorialStep4 from "assets/illustrations/tutorial/tutorial_step4.svg";
import type { ComponentType } from "react";
import { isNonRfidFlow } from "utils/nonRfidFlow";
import { NonRfidTutorialConfirmIllustration, NonRfidTutorialScanIllustration } from "./NonRfidTutorialIllustrations";

type TutorialStep = {
	title:
		| "tutorial.step1.title"
		| "tutorial.step2.title"
		| "tutorial.step3.title"
		| "tutorial.step4.title"
		| "tutorial.nonRfid.step1.title"
		| "tutorial.nonRfid.step2.title"
		| "tutorial.nonRfid.step3.title"
		| "tutorial.nonRfid.step4.title";
	svg: ComponentType;
};

export const TutorialSteps: readonly TutorialStep[] = [
	{
		title: "tutorial.step1.title",
		svg: TutorialStep1,
	},
	{
		title: "tutorial.step2.title",
		svg: TutorialStep2,
	},
	{
		title: "tutorial.step3.title",
		svg: TutorialStep3,
	},
	{
		title: "tutorial.step4.title",
		svg: TutorialStep4,
	},
];

/** Non-RFID prototype: the same four stages as the drawer — scan, open, take and close, confirm in the app. */
export const NonRfidTutorialSteps: readonly TutorialStep[] = [
	{
		title: "tutorial.nonRfid.step1.title",
		svg: NonRfidTutorialScanIllustration,
	},
	{
		title: "tutorial.nonRfid.step2.title",
		svg: TutorialStep2,
	},
	{
		title: "tutorial.nonRfid.step3.title",
		svg: TutorialStep3,
	},
	{
		title: "tutorial.nonRfid.step4.title",
		svg: NonRfidTutorialConfirmIllustration,
	},
];

export const getTutorialSteps = (): readonly TutorialStep[] => (isNonRfidFlow() ? NonRfidTutorialSteps : TutorialSteps);
